import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Routing from "./Routing";
import "./common.scss";
import MetaDecorator from "./components/MetaDecorator/MetaDecorator";
// Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// AOS styles
import Aos from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    Aos.init({
      duration: 1500,
      // disable: window.innerWidth < 1279,
      // once: true,
    });
  }, []);

  return (
    <>
      <MetaDecorator
        metaTitle="Chennai Singams: Lions of the Indian Street Premier League (ISPL)"
        metaDesc=" Meet the Chennai Singams. We're the living, breathing spirit of Chennai on the pitch."
        canonicalLink={window.location}
      />
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Routing />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;

// git push origin beta
